import classNames from 'classnames'
import React, { useState, useRef, useEffect, ReactNode } from 'react'

interface TooltipProps {
  text: string
  fullHeight?: boolean
  children: ReactNode
}

const UpdatedTooltip: React.FC<TooltipProps> = ({ text, children, fullHeight }) => {
  const [visible, setVisible] = useState(false)
  const [position, setPosition] = useState({ top: 0, left: 0 })
  const tooltipRef = useRef<HTMLDivElement | null>(null)
  const triggerRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (visible && tooltipRef.current && triggerRef.current) {
      const tooltip = tooltipRef.current
      const trigger = triggerRef.current
      const triggerRect = trigger.getBoundingClientRect()
      const tooltipRect = tooltip.getBoundingClientRect()
      const viewportWidth = window.innerWidth
      const viewportHeight = window.innerHeight

      let top = triggerRect.bottom + 8 // Default below trigger
      let left = triggerRect.left + triggerRect.width / 2 - tooltipRect.width / 2

      // Adjust for overflow
      if (left < 0) {
        left = 8
      }
      if (left + tooltipRect.width > viewportWidth) {
        left = viewportWidth - tooltipRect.width - 8
      }
      if (top + tooltipRect.height > viewportHeight) {
        top = triggerRect.top - tooltipRect.height - 8
      }

      setPosition({ top, left })
    }
  }, [visible])

  return (
    <div
      className={classNames('relative inline-block', fullHeight === true && 'h100')}
      ref={triggerRef}
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      {children}
      {visible && (
        <div
          ref={tooltipRef}
          className='bg-light-grey font-white h6 p1 rounded'
          style={{ top: `${position.top}px`, left: `${position.left}px`, position: 'fixed', zIndex: 1000 }}
        >
          {text.split('\n').map((line, index) => (
            <React.Fragment key={index}>
              {line}
              <br />
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
  )
}

export default UpdatedTooltip



// WEBPACK FOOTER //
// ./src/components/ui/UpdatedTooltip.tsx